module.exports = __webpack_public_path__ + "img/card-american-express.4a440d82.svg";